<div class="modal-header">
  <div class="h4" tabindex="0" ngbAutofocus>
    {{ request?.name }}
  </div>
  <button type="button" class="btn-close" aria-label="Close" [disabled]="isSubmitting" (click)="activeModal.dismiss('cross click')"></button>
</div>
<div class="modal-body">
  <div class="container">
    <div class="mb-3">
      <div [innerHTML]="request?.description">{{ request?.description }}</div>
    </div>
    <div class="mb-3">
        <text-input [(obj)]="updateRequest" prop="message"
                    label="Comments" [labelCols]="12"
                    [mode]="inputMode.TextArea" [maxLength]="500"></text-input>
      <div class="small">
        Let us know in the comments field if you need video access restricted. Comments are shared with the student and Academic Technologies once submitted.
      </div>
    </div>
    <div class="mb-3 fw-bold fs-6">Be aware that by granting permission all students in the course will have access to this recording.</div>
  </div>
</div>
<div class="modal-footer">
    @if (submit$ | async) {}
    <button type="button" class="btn btn-success" [disabled]="isSubmitting" (click)="approveRequest(true)">
        Approve @if (isSubmitting) { <i class="fa-solid fa-circle-notch fa-spin ms-1"></i> }
    </button>
    <button type="button" class="btn btn-danger" [disabled]="isSubmitting" (click)="approveRequest(false)">
        Deny @if (isSubmitting) { <i class="fa-solid fa-circle-notch fa-spin ms-1"></i> }
    </button>
    
    <button type="button" class="btn btn-outline-secondary" [disabled]="isSubmitting" (click)="activeModal.dismiss('close')">Close</button>
</div>
